import { render, staticRenderFns } from "./Intention.vue?vue&type=template&id=a6e9f0cc&scoped=true&"
import script from "./Intention.vue?vue&type=script&lang=js&"
export * from "./Intention.vue?vue&type=script&lang=js&"
import style0 from "./Intention.vue?vue&type=style&index=0&id=a6e9f0cc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e9f0cc",
  null
  
)

export default component.exports